import React from 'react';

const storageOptions = [
  "unter Dach",
  "frei bewittert"
];

const StorageSelect = ({ value, onChange, className }) => {
  const defaultClassName = "w-full p-3 bg-gray-50 border border-gray-100 rounded-xl appearance-none cursor-pointer text-gray-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all";

  return (
    <div className="relative">
      <select
        value={value}
        onChange={onChange}
        className={className || defaultClassName}
      >
        <option value="" disabled>Art der Lagerung</option>
        {storageOptions.map((type) => (
          <option key={type} value={type}>
            {type}
          </option>
        ))}
      </select>
      <div className="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none">
        <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </div>
  );
};

export default StorageSelect;